import PropTypes from 'prop-types';
import Translation from '../../lang/Translation';
import useStyles from './BasketItemImage.styles';

function BasketItemImage(props) {
  const classes = useStyles({...props});

  return (
    <span className={classes.basketItemImage} data-test="BasketItemImage">
      <span className={classes.imageContainer}>
        <img
          className={classes.image}
          data-test="BasketItemImage__image"
          alt={props.title}
          src={`https://${props.productUrl}`}
        />
        {props.additionalItems > 0 && props.isLastDisplayableItem && (
          <span className={classes.additionalItems} data-test="BasketItemImage__additionalItems">
            <span className={classes.moreItemsText}>
              <Translation placeholderValues={[props.additionalItems]}>
                orderSummary.more.items
              </Translation>
            </span>
          </span>
        )}
        {(props.quantity > 1 && !props.isDiggecardDeliveryOption) && (
          <span className={classes.quantity} data-test="BasketItemImage__badge" aria-hidden="true">
            {props.quantity}
          </span>
        )}
      </span>
    </span>
  );
}

BasketItemImage.defaultProps = {
  additionalItems: 0,
  isLastDisplayableItem: false,
  mergedGroupsEnabled: false,
};

BasketItemImage.propTypes = {
  productUrl: PropTypes.string.isRequired,
  quantity: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  additionalItems: PropTypes.number,
  isLastDisplayableItem: PropTypes.bool,
  mergedGroupsEnabled: PropTypes.bool,
  isDiggecardDeliveryOption: PropTypes.bool,
};

export default BasketItemImage;
